module.exports = __webpack_public_path__ + "static/media/dog_300x300.a7cfe21d.png";